import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Elementos de contextualización' }
  },
  {
    path: '/accionProblemica',
    name: 'AP',
    component: () => import(/* webpackChunkName: "accionProblemica" */ '../views/AP.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Acción problémica' }
  },
  {
    path: '/conocimientosPrevios',
    name: 'CP',
    component: () => import(/* webpackChunkName: "conocimientosPrevios" */ '../views/CP.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Act. Conocimientos previos' }
  },
  {
    path: '/Tema1',
    name: 'Tema1',
    component: () => import(/* webpackChunkName: "Tema1" */ '../views/Tema1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 1' }
  },
  {
    path: '/Tema1_1.1',
    name: 'Tema1_1-1',
    component: () => import(/* webpackChunkName: "Tema1_1.1" */ '../views/Tema1_1-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 1 - 1.1' }
  },
  {
    path: '/Tema1_1.2',
    name: 'Tema1_1-2',
    component: () => import(/* webpackChunkName: "Tema1_1.2" */ '../views/Tema1_1-2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 1 - 1.2' }
  },
  {
    path: '/Tema1_1.3',
    name: 'Tema1_1-3',
    component: () => import(/* webpackChunkName: "Tema1_1.3" */ '../views/Tema1_1-3.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 1 - 1.3' }
  },
  {
    path: '/Tema2',
    name: 'Tema2',
    component: () => import(/* webpackChunkName: "Tema2" */ '../views/Tema2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 2' }
  },
  {
    path: '/Tema2_2.1',
    name: 'Tema2_2-1',
    component: () => import(/* webpackChunkName: "Tema2_2.1" */ '../views/Tema2_2-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 2 - 2.1' }
  },
  {
    path: '/Tema2_2.2',
    name: 'Tema2_2-2',
    component: () => import(/* webpackChunkName: "Tema2_2.2" */ '../views/Tema2_2-2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 2 - 2.2' }
  },
  {
    path: '/Tema2_2.3',
    name: 'Tema2_2-3',
    component: () => import(/* webpackChunkName: "Tema2_2.2" */ '../views/Tema2_2-3.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 2 - 2.3' }
  },
  {
    path: '/Tema2_2.4',
    name: 'Tema2_2-4',
    component: () => import(/* webpackChunkName: "Tema2_2.2" */ '../views/Tema2_2-4.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Tema 2 - 2.4' }
  },
  {
    path: '/actividadSeguimiento',
    name: 'AS',
    component: () => import(/* webpackChunkName: "autoEvaluacion" */ '../views/AS.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Act. Seguimiento' }
  },
  {
    path: '/autoEvaluacion',
    name: 'AE',
    component: () => import(/* webpackChunkName: "autoEvaluacion" */ '../views/AE.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Act. Autoevaluación' }
  },
  {
    path: '/finUnidad',
    name: 'Fin',
    component: () => import(/* webpackChunkName: "finUnidad" */ '../views/FIN.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Fin de la unidad' }
  },
  {
    path: '/referenciasBibliograficas',
    name: 'REF',
    component: () => import(/* webpackChunkName: "referenciasBibliograficas" */ '../views/REF.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Referencias bibliográficas' }
  },
  {
    path: '/creditos',
    name: 'Creditos',
    component: () => import(/* webpackChunkName: "creditos" */ '../views/CRED.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 1 / Créditos' }

  }
  
  
]

const router = new VueRouter({
  routes
})

export default router
